<div class="hdwi-dialog">
  <div class="hdwi-header">
    <div class="hdwi-title-wrap">
      <h2 class="hdwi-title">Staff attendance images</h2>
      <p class="hdwi-sub" *ngIf="data.campusName || data.hygieneDate">
        <span *ngIf="data.campusName">{{ data.campusName }}</span>
        <span *ngIf="data.campusName && data.hygieneDate"> · </span>
        <span *ngIf="data.hygieneDate">{{ data.hygieneDate }}</span>
      </p>
    </div>
    <div class="hdwi-actions" *ngIf="!loading && !errorMessage && currentImage">
      <button type="button" class="hdwi-action-btn" (click)="rotateLeft()" aria-label="Rotate left">
        <i class="fa fa-undo" aria-hidden="true"></i>
      </button>
      <button type="button" class="hdwi-action-btn" (click)="rotateRight()" aria-label="Rotate right">
        <i class="fa fa-redo" aria-hidden="true"></i>
      </button>
      <button type="button" class="hdwi-action-btn" [disabled]="rotationDeg === 0" (click)="resetRotation()"
        aria-label="Reset rotation">
        <i class="fa fa-sync-alt" aria-hidden="true"></i>
      </button>
    </div>
    <button type="button" class="hdwi-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="hdwi-body">
    <div *ngIf="loading" class="hdwi-state">Loading…</div>

    <ng-container *ngIf="!loading">
      <div *ngIf="errorMessage" class="hdwi-error-banner">{{ errorMessage }}</div>

      <ng-container *ngIf="!errorMessage">
        <div class="hdwi-info-card" *ngIf="currentImageInfo  as g">
          <div class="hdwi-info-top">
            <div class="hdwi-building" [attr.title]="g.buildingName || ''">
              {{ g.buildingName || data.campusName || '—' }}
            </div>
            <div class="hdwi-pin-row">
              <div class="hdwi-pin-cell" *ngIf="hasCampusLocation(g)">
                <button type="button" class="hdwi-pin" (click)="openMap('campus')" title="Captures map"
                  aria-label="Open captures location on map">
                  <img class="hdwi-pin-img" [src]="mapIconPath" alt="" />
                </button>
                <span class="hdwi-pin-label">Capture</span>
              </div>
              <div class="hdwi-pin-cell" *ngIf="hasBuildingLocation(g)">
                <button type="button" class="hdwi-pin" (click)="openMap('building')" title="Building map"
                  aria-label="Open building location on map">
                  <img class="hdwi-pin-img" [src]="mapIconPath" alt="" />
                </button>
                <span class="hdwi-pin-label">Building</span>
              </div>
              <div class="hdwi-pin-cell" *ngIf="!hasCampusLocation(g) && !hasBuildingLocation(g)">
                <button type="button" class="hdwi-pin" (click)="openMap('auto')" [attr.aria-label]="mapPinAriaLabel(g)"
                  title="Search location">
                  <img class="hdwi-pin-img" [src]="mapIconPath" alt="" />
                </button>
                <span class="hdwi-pin-label">Search</span>
              </div>
            </div>
          </div>

          <div class="hdwi-info-lines">
            <div class="hdwi-line" *ngIf="g.employeeName">{{ g.employeeName }}</div>
            <div class="hdwi-line" *ngIf="g.designation">{{ g.designation }}</div>
            <div class="hdwi-line" *ngIf="g.mobileNo">{{ g.mobileNo }}</div>
          </div>

          <div class="hdwi-info-bottom">
            <div class="hdwi-dept">{{ g.departmentName || '—' }}</div>
            <div class="hdwi-right">
              <div class="hdwi-staff" *ngIf="g.staffCount != null">{{ g.staffCount }} staff</div>
              <div class="hdwi-time" *ngIf="currentImage as img">{{ caption(img) || '' }}</div>
            </div>
          </div>
        </div>

      </ng-container>

  
      <div class="hdwi-viewer-row">

        <button type="button" class="hdwi-nav-sq" (click)="prev()" [disabled]="!canGoPrev">

          <i class="fa fa-chevron-left"></i>

        </button>

        <div class="hdwi-viewer-center">

          <figure class="hdwi-card" *ngIf="currentImage as img">

            <div class="hdwi-frame" role="img"
              [attr.aria-label]="'Attendance image ' + (selectedIndex + 1) + ' of ' + allImages.length">

              <img class="hdwi-img" [src]="img.url" [style.transform]="'rotate(' + rotationDeg + 'deg)'" alt=""
                draggable="false" />

            </div>

            <figcaption class="hdwi-cap">
              {{ caption(img) || '—' }}
            </figcaption>

          </figure>

          <div *ngIf="!currentImage" class="hdwi-placeholder">
            <i class="fa fa-image hdwi-placeholder-icon"></i>
            <span>No image found.</span>
          </div>

          <p class="hdwi-img-count" *ngIf="allImages.length > 0">
            {{ selectedIndex + 1 }} / {{ allImages.length }}
          </p>

        </div>

        <button type="button" class="hdwi-nav-sq" (click)="next()" [disabled]="!canGoNext">

          <i class="fa fa-chevron-right"></i>

        </button>

      </div>
    </ng-container>
  </div>
</div>